import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { memberDetailActions } from 'features/member/reducer/memberDetailSlice';

import AddCommentModal from './addComentModal';
import InformModal from 'components/common/modal/InformModal';
import DeleteModal from 'components/common/modal/DeleteModal';

import { UpdateCommentItemType } from '../column';
import { Comment } from 'types/member';

interface Props {
  userId: string;
  selectedComment: Comment;
  selectedModalType?: UpdateCommentItemType;
  onModalClose: () => void;
}

const CommentModals = ({ userId, selectedComment, selectedModalType, onModalClose }: Props) => {
  const dispatch = useDispatch();

  const [isCommentModalOpen, setIsCommentModalOpen] = useState<boolean>(false);
  const [isDeleteCommentModalOpen, setIsDeleteCommentModalOpen] = useState<boolean>(false);
  const [isInvalidDateModalOpen, setIsInvalidDateModalOpen] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const deleteComment = () => {
    const { id, partitionKey, writeBy } = selectedComment;

    dispatch(
      memberDetailActions.deleteMemberComment({ userId, id, partitionKey, writeBy, reFetch: true }),
    );
    setIsDeleteCommentModalOpen(false);
  };

  useEffect(() => {
    switch (selectedModalType) {
      case 'add':
      case 'edit': {
        setIsCommentModalOpen(true);
        return;
      }
      case 'delete': {
        setIsDeleteCommentModalOpen(true);
        return;
      }
    }
  }, [selectedModalType]);

  useEffect(() => {
    const isAllClosed = [
      isCommentModalOpen,
      isDeleteCommentModalOpen,
      isInvalidDateModalOpen,
    ].every(isOpen => !isOpen);

    if (isAllClosed) {
      onModalClose?.();
    }
  }, [isCommentModalOpen, isDeleteCommentModalOpen, isInvalidDateModalOpen]);

  return (
    <>
      <InformModal
        open={isInvalidDateModalOpen}
        onClose={() => setIsCommentModalOpen(false)}
        description={errorMessage}
      />
      {isCommentModalOpen && (
        <AddCommentModal
          userId={userId}
          commentModalOpen={isCommentModalOpen}
          setErrorMessage={setErrorMessage}
          selectedComment={selectedComment}
          setInvalidDateModalOpen={setIsInvalidDateModalOpen}
          closeCommentModal={() => setIsCommentModalOpen(false)}
          setCommentModalOpen={() => setIsCommentModalOpen(false)}
        />
      )}
      <DeleteModal
        open={isDeleteCommentModalOpen}
        onClose={() => setIsDeleteCommentModalOpen(false)}
        content={<>Are you sure you want to delete ?</>}
        onDelete={deleteComment}
      />
    </>
  );
};

export default CommentModals;
